import { defineMessages } from 'utils/intl';

export default defineMessages({
  version: 'API version: {apiVersion}. Client version: {clientVersion}',
});
